<script>
    import Stroke from "./Stroke.svelte";

    export let style;

    $: stroke = style && style.stroke || {};
</script>

<Stroke on:changeStyle {stroke} />